import { useLayoutEffect, useRef, useEffect } from 'react';
import { useEventCallback } from '../useEventCallback';
/**
 * only trigger when re-render, not trigger on component first render
 */
export var useOnReRender = function (cb, deps, isLayout) {
    if (isLayout === void 0) { isLayout = true; }
    var count = useRef(0);
    var method = useEventCallback(cb);
    var isLayoutRef = useRef(isLayout);
    var useTargetEffect = isLayoutRef.current ? useLayoutEffect : useEffect;
    useTargetEffect(function () {
        if (count.current === 0) {
            count.current = 1;
            return function () { };
        }
        var destroy = method();
        return destroy;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
